export const stationStatus = {
  active: 2,
  archived: 3
}

export const getStatusList = () => {
  var statusList = [];
  for (var key in stationStatus) {
    statusList.push({
      name: key, value: stationStatus[key]
    });
  }
  return statusList;
}